import { useContext } from 'react';
import { GlobalContext } from '@/components';

import type { GlobalData } from '@/components';

const useGlobalStore = (): GlobalData => useContext(GlobalContext);

export default useGlobalStore;
